// import jQuery from 'CommonScripts/jquery-1.10.2'; 
import trackGoogleEvent from 'GlobalsScript/googleanalytics';

(function (window, document, $) {

    $(document).ready(function () {
        var imagesLoaded = require('imagesloaded');
        imagesLoaded.makeJQueryPlugin( $ );
        /* Load the Hero Slideshow functionality when it exists on the page */
        // $.components.registerComponent('main .slideshowContainer', function ($root) {
        /* Create Hero object with all settings */
        var $root = document.querySelectorAll('main .slideshowContainer');
            $root = $($root);   
            var Hero = {
                dom: {
                    base: $root,
                    slideshow: $root.find('.slideshow'),
                    slideWrapper: $root.find('.slide-wrapper'),
                    slides: $root.find('.slides'),
                    slide: $root.find('.slide'),
                    slideImage: $root.find('.slide-image > img'),
                    nav: $root.find('.slider-index'),
                    navItem: $root.find('.slider-index .index'),
                    counter: function () { return $dom.navItem.filter('.active').find('.slide-counter'); },
                    direction: $root.find('.slider-nav'),
                    activeSlide: function () { return $dom.slide.filter('.active'); },
                    nextSlide: function() {

                        return $dom.slide.eq($set.nextIndex);
                    },
                    nextImage: function () { return $dom.slideImage.eq($set.nextIndex); }
                },
                set: {
                    speed: parseInt($root.attr('data-animationtime')), //500
                    style3height: 0,
                    prevImageSize:0,
                    delay: parseInt($root.attr('data-speed')),
                    animation: 'linear',
                    animationType: $root.attr('data-animation'),
                    direction: -1,
                    sliding: false,
                    loaded: false,
                    timeout: null,
                    nextIndex: 1, /* Defaults to 1 */
                    currentOrientation: 0
                },
                fn: {
                    /* Initiate the Hero and start the first slide */
                    startHero: function () {
                        /* Create counter elements to track how long is left when pausing the hero */
                        $dom.navItem.append('<div class="slide-counter"></div>');
                        $fn.startCounter();

                        if ($set.loaded == false && $dom.slideshow.parents('slideshowspot').hasClass('slideshowLoaded') == false) {
                            $set.loaded = true;

                            for (var i = 0; i < $dom.slide.length; i++) {

                                $($dom.slide[i]).find("a").on("click",
                                    function () {
                                        var slide = $(this).closest(".slide");
                                        var slideImage = $(slide).find(".slide-image > img");
                                        var imageFilename = slideImage[0] ? $(slideImage).attr("src").replace(/^.*[\\\/]/, "").split("?")[0] : "NoImage";
                                        trackGoogleEvent("Picture Carousel", "Explore now", imageFilename, false);
                                    });

                                $set.substractHeight = (parseInt($dom.slideImage.eq(i).attr('height'))) - (parseInt($dom.slideshow.height()));
                                $set.substractWidth = (parseInt($dom.slideImage.eq(i).attr('width'))) - (parseInt($dom.slideshow.width()));
                                if ($set.substractHeight > 0 || $set.substractWidth > 0) {
                                    if ($set.substractWidth > $set.substractHeight) {
                                        $dom.slideImage.eq(i).css({ height: "auto", width: "100%", bottom: "auto" });
                                    }
                                } else {
                                    $dom.slideImage.eq(i).css({ height: "auto", width: "auto", bottom: "auto" });
                                }
                            }
                            trackGoogleEvent("Picture Carousel", "Load Slideshow", "NoImage", true);

                        }
                        $set.timeout = setTimeout(function () { $fn.switchSlide(); }, $set.delay);
                        
                        // Placing all the slides left top corner in the placeholder. Switching only z-index and display between slides
                        if ($set.animationType == 'fadein') {
                            $fn.fadeInInit();
                        }
                    },
                    /* Count height for a hero style-3 when loaded*/
                    countHeroSize: function () {
                        var heighest_not_lazy_image = 0;
                        for (var i = 0; i < $dom.slide.length; i++) {
                            var content_height = $dom.slide.eq(i).find('> section').outerHeight(true) - 2;
                            var image_height = $dom.slideImage.eq(i).height();
                            if (!$dom.slideImage.eq(i).hasClass("lazy") && image_height > heighest_not_lazy_image) {
                                heighest_not_lazy_image = image_height;
                            }
                            var current_height = heighest_not_lazy_image + content_height;
                            if (current_height > $set.style3height) {
                                $set.style3height = current_height;
                            }
                        }
                        $dom.slideWrapper.css('height', $set.style3height + 'px');
                        $set.style3height = 0;
                    },
                    addSlideCounter: function (){
                        var currentSlide = 0;
                        var firstSlide = 'active';
                        $dom.slide.each(function () {
                            $dom.nav.append('<div  class="index ' + firstSlide + '"><i class="velux-icon icon-rotator-nav-light"></i><div class="slide-title"></div><div class="slide-counter" style="width: 0%;"></div></div>');
                            firstSlide = '';
                            currentSlide++;
                        });
                        $dom.base.find('.slide-wrapper > div:first-child').addClass('active');
                        $dom.navItem = $root.find('.slider-index .index');
                    },
                    fadeInInit: function () {
                        $dom.slide.css({ 'z-index': -1, 'left': 0, 'top': 0 });
                        $dom.nextSlide().hide();
                        $dom.nextSlide().css({ 'z-index': 1 });
                        $dom.activeSlide().css({ 'z-index': 0 });
                    },
                    /* Switch between slides. By default, switch to the next slide, if index is included switch to that one */
                    switchSlide: function () {
                        /* Always clear the current timeout */
                        clearTimeout($set.timeout);
                        $dom.counter().stop();

                        /* Use sliding var to see whether a slide is already animating. Return if true */
                        if ($set.sliding == true) {
                            return;
                        }
                        $set.sliding = true;


                        switch ($set.animationType) {
                            case 'fadein':
                                // Making sure they are all invisible and they won't overlap when change
                                $dom.slide.hide();
                                $dom.activeSlide().show();

                                /* Removing the active class, preparing to give it to the next */
                                $dom.activeSlide().removeClass('active');
                                $fn.fadeInInit();

                                $dom.nextSlide().fadeIn($set.speed, function () {
                                    $(this).addClass('active');
                                    $set.sliding = false;
                                    $set.direction = -1;

                                    /* Pre-set the index of the next slide when automatically triggered */
                                    $set.nextIndex = ($dom.activeSlide().next('.slide').length > 0) ? $dom.activeSlide().next().index() : 0;
                                    $fn.fadeInInit();

                                    $set.timeout = setTimeout(function () { $fn.switchSlide(); }, $set.delay);

                                    /* Reset the active classes for the nav items and start the counter */
                                    $dom.navItem.removeClass('active');
                                    $dom.navItem.eq($(this).index()).addClass('active');
                                    $fn.startCounter();
                                });
                                break;

                            case 'slide':
                                /* Animate the active slide out of the frame */
                                $dom.activeSlide().animate({ left: (100 * $set.direction) + '%' }, $set.speed, $set.animation, function () {
                                    $(this).removeClass('active');
                                });
                                /* Animate the new slide into the frame */
                                $dom.nextSlide().css({ left: (-100 * $set.direction) + '%' }).animate().animate({ left: '0%' }, $set.speed, $set.animation, function () {
                                    $(this).addClass('active');
                                    $set.sliding = false;
                                    $set.direction = -1;


                                    /* Pre-set the index of the next slide when automatically triggered */
                                    $set.nextIndex = ($dom.activeSlide().next('.slide').length > 0) ? $dom.activeSlide().next().index() : 0;
                                    $set.timeout = setTimeout(function () { $fn.switchSlide(); }, $set.delay);

                                    /* Reset the active classes for the nav items and start the counter */
                                    $dom.navItem.removeClass('active');
                                    $dom.navItem.eq($(this).index()).addClass('active');
                                    $fn.startCounter();
                                });
                                break;
                        }
                    },

                    /* Starts the Slideshow counter in the active slide-nav-item */
                    startCounter: function () {
                        /* First reset the widths of all counters, then animate the active one */
                        $dom.navItem.find('.slide-counter').css({ width: '0%' });
                        $dom.counter().stop().css({ width: '0%' }).animate({ width: '100%' }, $set.delay, $set.animation);
                    },

                    /* remove navigation (in case it's only 1 slide) */
                    removeNavigation: function () {
                        $dom.direction.remove();
                        $dom.nav.remove();
                    }
                }
            },
            $dom = Hero.dom,
            $set = Hero.set,
            $fn = Hero.fn;

            $dom.base.imagesLoaded().always(function () {
                if ($(window).width() < 768 && $dom.base.hasClass('style-3') == true) {
                    $fn.countHeroSize();
                }
            });

            $fn.addSlideCounter();
            /* Start the Hero when there are more than 1 slides */
            if ($dom.slide.length > 1) {
                $fn.startHero();
            } else {
                $fn.removeNavigation();
            }

            /* Initiate switching a slide when clicking on a nav item */
            $dom.navItem.on({
                click: function () {
                    if (!$(this).hasClass('active')) {
                        /* Set the direction depending on the selected index and the active index */
                        $set.direction = ($(this).index() < $dom.navItem.filter('.active').index()) ? 1 : -1;

                        $set.nextIndex = $(this).index();
                        $fn.switchSlide();
                    }
                    
                }
            });

            /* Initiate switch a slide when clicking on the directional buttons + change direction */
            $dom.direction.on({
                click: function () {
                    $set.direction = ($(this).hasClass('left')) ? 1 : -1;

                    $set.nextIndex = $dom.activeSlide().index() - $set.direction;
                    if ($set.nextIndex == $dom.slide.length) {
                        $set.nextIndex = 0;
                    }

                    // track googleevent
                    var slideImage = $dom.activeSlide().find("img");
                    var imageFilename = slideImage[0] ? $(slideImage).attr("src").replace(/^.*[\\\/]/, "").split("?")[0] : "NoImage";
                    trackGoogleEvent("Picture Carousel", "Click next", imageFilename, false);

                    $fn.switchSlide();
                }
            });

            /* Pause the timeout when hovering over the Hero */
            $dom.slideshow.on({
                mouseover: function () {
                    if ($set.timeout) {
                        clearTimeout($set.timeout);
                        $set.timeout = null;
                        $dom.counter().stop();
                    }
                },
                mouseleave: function () {
                    if (!$set.sliding && $dom.slide.length > 1) {
                        var newDelay = $set.delay * ((100 - parseInt($dom.counter()[0].style.width)) / 100);

                        $set.timeout = setTimeout(function () { $fn.switchSlide(); }, newDelay, $set.animation);
                        $dom.counter().animate({ width: '100%' }, newDelay, $set.animation);
                    }
                }
            });
            /* Recalculate size for hero style-3 */
            $(window).on("resize", function () {
                if ($(window).width() < 768 && $dom.base.hasClass('style-3') == true) {
                    var screenOrientation = ($(window).width() > $(window).height()) ? 90 : 0;
                    if ($set.currentOrientation != screenOrientation) {
                        $set.currentOrientation = screenOrientation;
                        $fn.countHeroSize();
                    }
                }
            });
            /* Handle swipe on touchscreen for changing slides */
            function handleSwipe() {
                var swipeHandler = new Object();
                swipeHandler.startX = 0; swipeHandler.endX = 0;
                var minX = 100;  //min x for swipe to take effect
                var direction = "";
                var elem = $dom.slideshow.get();

                if (elem && elem.length > 0) {
                    elem[0].addEventListener('touchstart', function (e) {
                        var t = e.touches[0];
                        swipeHandler.startX = t.screenX;
                    }, false);
                    elem[0].addEventListener('touchmove', function (e) {
                        e.stopPropagation();
                        var t = e.touches[0];
                        swipeHandler.endX = t.screenX;
                    }, false);
                    elem[0].addEventListener('touchend', function (e) {
                        //horizontal swipe
                        if (swipeHandler.endX != 0 && ((swipeHandler.endX - minX > swipeHandler.startX) || (swipeHandler.endX + minX < swipeHandler.startX))) {
                            if (swipeHandler.endX > swipeHandler.startX) direction = "r";
                            else direction = "l";
                        }
                        if (direction != "") {
                            changeSlideAfterSwipe(direction);
                        }
                        direction = "";
                        swipeHandler.startX = 0; swipeHandler.endX = 0;
                    }, false);
                }
            }

            function changeSlideAfterSwipe(d) {
                if (d == "r") { $set.direction = 1;}
                if (d == "l") { $set.direction = -1;}

                $set.nextIndex = $dom.activeSlide().index() - $set.direction;
                if ($set.nextIndex == $dom.slide.length) {
                    $set.nextIndex = 0;
                }
             
                $fn.switchSlide();
            }

            handleSwipe();
    });// document ready
})(window, document, jQuery);

